/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcreator1Inputs */

const en_eventcreator1 = /** @type {(inputs: Eventcreator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Creator`)
};

const de_eventcreator1 = /** @type {(inputs: Eventcreator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Assistent`)
};

/**
* | output |
* | --- |
* | "Event Creator" |
*
* @param {Eventcreator1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcreator1 = /** @type {((inputs?: Eventcreator1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcreator1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcreator1(inputs)
	return de_eventcreator1(inputs)
});
export { eventcreator1 as "eventCreator" }